import { useRouter } from "next/router"
import cn from "classnames"
import Image from "next/legacy/image"

import Button from "../newButton/Button"
import { rgbDataURL } from "./lib/utils"
import { handleReserve } from "./lib/handlers"
import ButtonAsk from "./lib/buttonAsk"
import { Dog } from "@/types/commonTypes"

import styles from "./Keypad.module.scss"

interface KeypadProps {
  dog: Dog
  showImage?: boolean
  salePrice?: number
  dataApplication?: any | undefined
  updatedData?: Dog | undefined
}

export default function Keypad({
  dog,
  showImage,
  salePrice,
  dataApplication,
  updatedData,
}: KeypadProps) {
  const router = useRouter()

  if (!updatedData?.isAvailable) {
    return (
      <div className={cn(styles.keypad, styles.notAvailable)}>
        <img src="/puppy/family-house.svg" alt="family house icon" />

        <h4>This puppy has found a forever home.</h4>

        <Button
          title="Browse Others"
          onClick={() => router.push("/search")}
          theme={["medium", "pink-solid"]}
          style={{ width: "280px" }}
        />
      </div>
    )
  }

  return (
    <div className={styles.keypad}>
      {showImage && (
        <div className={styles.image}>
          <Image
            width={290}
            height={290}
            src={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${dog?.profilePicture?.medium}`}
            placeholder="blur"
            blurDataURL={rgbDataURL(238, 238, 238)}
            alt={dog.name}
          />
        </div>
      )}

      {!isNaN(salePrice as number) && salePrice! > 0 && (
        <div className={styles.buttons}>
          <ButtonAsk special dataPuppy={updatedData} />

          <Button
            title="Reserve Me"
            theme={["medium", "green-solid"]}
            onClick={() => handleReserve(dog, router, dataApplication)}
            style={{
              width: "100%",
            }}
          />
        </div>
      )}
    </div>
  )
}
